export * from './delete-objekt.service';
export * from './delete-objekt.service.module';